import React, { Suspense, lazy } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";

const About      = lazy(() => import("../pages/About"));
const Education  = lazy(() => import("../pages/Education"));
const Experience = lazy(() => import("../pages/Experience"));
const Services   = lazy(() => import("../pages/Services"));

function PageLoader() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#080a0e",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: "12px",
        color: "#4d5666",
        letterSpacing: "0.15em",
      }}>
        Loading...
      </div>
    </div>
  );
}

export default function Main() {
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={<PageLoader />}>
        <Switch>
          <Route path="/"          exact component={About} />
          <Route path="/education"       component={Education} />
          <Route path="/experience"      component={Experience} />
          <Route path="/services"        component={Services} />
          <Route path="*"                component={About} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}
